module.exports = "pegasus/assets/blocks/image-3-tech.png";